import * as _ from 'lodash';
import * as display from './display';
import * as validate from './validate';
import * as language from './language';
import * as localStorage from './localStorage';
import * as addon from './addon';
import * as jwt from './jwt'
import * as data from './data'
import * as stream from './stream'
import * as permission from './permission'
import moment from 'moment';

export default defineNuxtPlugin((nuxtApp: any) => {
  return {
    provide: {
      _,
      moment,
      functions: {
        notify: {
          success: (props: any) => {
            props.group = 'tailwind';
            props.data = {
              ...props,
            };
            nuxtApp.$notify(props);
          },
          error: (props: any) => {
            props.group = 'tailwind';
            props.data = {
              ...props,
              isError: true,
            };
            nuxtApp.$notify(props);
          },
        },
        ...validate,
        ...display,
        ...language,
        ...localStorage,
        ...addon,
        ...jwt,
        ...data,
        ...stream,
        ...permission,
      },
    },
  };
});
